import { BgColorsOutlined } from "@ant-design/icons";
import MasterCrudScreen from "./Mastercrudscreen";
import { MASTERS } from "./Masterapi";
import { ROSE, AMBER } from "./Mastertheme";

const config = {
    master: MASTERS.colour,
    title: "Colour Master",
    singular: "Colour",
    plural: "Colours",
    subtitle: "Manage product colours",
    icon: <BgColorsOutlined />,
    from: ROSE,
    to: AMBER,
    fields: [
        { name: "colour", label: "Colour", placeholder: "e.g. NAVY BLUE", required: true, icon: <BgColorsOutlined /> },
    ],
};

export default function ColourMaster() {
    return <MasterCrudScreen config={config} />;
}